import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { SliderButton } from './sliderButton/SliderButton';

import styles from './timeline.module.css';

const hours = Array.from({ length: 24 }, (_, i) => (i + 3) % 24);

function formatHour(hour: number) {
  return `${hour.toString().padStart(2, '0')}:00`;
}

function getCurrentMinutesSince3AM() {
  const now = new Date();
  const minutes = now.getHours() * 60 + now.getMinutes();
  // 1440 minutes in a day - 180 minutes (3 hours) from midnight
  return (minutes - 180 + 1440) % 1440;
}

export const Timeline: React.FC = () => {
  const [sliderHour, setSliderHour] = useState(getCurrentMinutesSince3AM());
  const [trackWidth, setTrackWidth] = useState(0);
  const [currentMinutes, setCurrentMinutes] = useState(getCurrentMinutesSince3AM());
  const timelineRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (timelineRef.current) {
      setTrackWidth(timelineRef.current.offsetWidth - 40); // Subtract button width
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMinutes(getCurrentMinutesSince3AM());
    }, 60_000);
    // Update immediately in case the component mounts mid-minute
    setCurrentMinutes(getCurrentMinutesSince3AM());
    return () => clearInterval(interval);
  }, []);

  const currentPercent = trackWidth ? currentMinutes / 1380 : 0;
  const currentLeft = trackWidth ? currentPercent * trackWidth + 18 : 0;

  return (
    <div className={styles.fixedContainer} style={{ width: trackWidth || 'auto' }}>
      <div className={styles.innerContainer} style={{ width: trackWidth }}>
        <SliderButton min={0} max={1380} value={sliderHour} onChange={setSliderHour} trackWidth={trackWidth} />
        <div className={styles.timeline} ref={timelineRef}>
          <div className={styles.currentTimeLine} style={{ left: currentLeft }} data-testid='current-time-line' />
          {hours.map((hour) => (
            <div key={hour} className={styles.hourBlock}>
              <div className={styles.hourLabel}>{formatHour(hour)}</div>
              <div className={styles.hourTick}>|</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
